import React, { useEffect, useState } from "react";
import { Menu, MenuItem, MenuButton, useAuthenticator, ButtonVariations, Loader } from "@aws-amplify/ui-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getTaskAlertAPI } from "../../data/api";
import { Modal } from "react-bootstrap";
import TaskModal from "../../pages/task/TaskModal";
import emitter from "../../eventBus/EventBus";

const TaskMenu = (props) => {

  // create modal
  const [showCreateModal, setShowCreateModal] = useState(false);
  const closeCreateModal = () => setShowCreateModal(false);
  const openCreateModal = () => setShowCreateModal(true);

  const navigate = useNavigate();
  const location = useLocation();
  const [buttonState, setButtonState] = useState('primary');
  const [alertCount, setAlertCount] = useState(undefined);
  const [loading, setLoading] = useState(false);
  
  const getButtonState = async () => {
    try{
      setLoading(true);
      const alert = await getTaskAlertAPI();
      setButtonState(alert.has_alert ? 'destructive' : 'primary')
      setAlertCount(alert.count)
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setAlertCount('-')
      console.log("Error setting alert button state", e)
    }
  }

  // Use effect to listen to the updatedTask event
  useEffect(() => {
    emitter.on('updatedTask', getButtonState);

    // Cleanup function to remove the listener
    return () => {
      emitter.off('updatedTask', getButtonState);
    };
  }, []);

  useEffect(() => {
    getButtonState();
  }, [])
  
  return (
    <>
      <Menu
        menuAlign="end"
        trigger={
          <MenuButton variation={buttonState as ButtonVariations}>
              <div><span>{loading ? <Loader/> : alertCount !== undefined ? 'Task ('+alertCount+')' : 'Task'}</span></div>
          </MenuButton>
        }
      >
        <MenuItem onClick={() => navigate("/task")}>Visualizza task</MenuItem>
        <MenuItem onClick={openCreateModal}>Crea nuovo task</MenuItem>
      </Menu>
      <Modal show={showCreateModal} onHide={closeCreateModal}>
        <Modal.Header closeButton>
          <Modal.Title>Crea nuovo task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TaskModal onCreate={closeCreateModal}/>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TaskMenu;
